import { AmplifyAuthConfig, AmplifyAuthenticator, Authenticator, isAuth0Authenticated } from '../../authenticator';
import { ROUTES } from '../constants';
import { joinRouteMatchPath } from '../../path';

/** Amplify Auth configuration */
const redirectSignInPath = joinRouteMatchPath('', ROUTES.FEDERATED_SIGN_IN_REDIRECT);
const redirectSignOutPath = joinRouteMatchPath('', ROUTES.LOGIN);

const authConfig: AmplifyAuthConfig = {
  Auth: {
    identityPoolId: window.__env__.AWS_IDENTITY_POOL_ID,
    region: window.__env__.AWS_REGION,
    userPoolId: window.__env__.AWS_USER_POOL_ID,
    userPoolWebClientId: window.__env__.AWS_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: window.__env__.AWS_USER_POOL_WEB_CLIENT_DOMAIN,
      clientId: window.__env__.AWS_USER_POOL_WEB_CLIENT_ID,
      scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: `${window.location.origin}${redirectSignInPath}`,
      redirectSignOut: `${window.location.origin}${redirectSignOutPath}`,
      responseType: 'code'
    }
  }
};

/** Authenticator Singleton instance */
let _instance: Authenticator<AmplifyAuthConfig> | undefined;

const initializeAuthenticator = () => {
  if (!_instance && !window.location.pathname.includes(ROUTES.SAGE_ID_SIGN_IN_TRIGGER) && !isAuth0Authenticated()) {
    _instance = new AmplifyAuthenticator(authConfig);
  }
  return _instance;
};

const authenticator = initializeAuthenticator();

const getAuthenticator = (): Authenticator<AmplifyAuthConfig> => {
  const instance = initializeAuthenticator();
  if (!instance) {
    throw new Error('Authenticator is not initialized');
  }
  return instance;
};

export { authenticator, initializeAuthenticator, getAuthenticator };
